import { Card, Skeleton, Space } from '@sravni/react-design-system';
import React from 'react';

import styles from './LimitApprovalSkeleton.module.scss';

export const LimitApprovalSkeleton = () => {
  return (
    <Space direction="vertical">
      <Card
        className={styles.date}
        variant="primary"
        color="green"
      >
        <Space
          size={4}
          justify="center"
          className="h-color-G200"
        >
          <Skeleton.Paragraph
            width={80}
            className={styles.skeletonTop}
          />
        </Space>
      </Card>
      <Card
        variant="primary"
        color="green"
        className={styles.card}
      >
        <Space
          direction="vertical"
          align="center"
          size={12}
        >
          <Space
            direction="vertical"
            align="center"
            size={4}
          >
            <Skeleton.Paragraph
              width={40}
              className={styles.skeletonSmall}
            />
            <Skeleton.Paragraph
              width={60}
              className={styles.skeletonMedium}
            />
          </Space>
          <Skeleton.Paragraph className={styles.skeletonLarge} />
        </Space>
      </Card>
    </Space>
  );
};
